import { Select, Tooltip } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  h6 {
    font-size: 12px;
    font-weight: 700;
    color: #bfbfbf;
  }
`;
export const Divider = styled.span`
  width: 100%;
  height: 1px;
  background: #d9d9d9;
  margin-bottom: 10px;
  margin-top: 15px;
  display: block;
`;
export const CodeControl = styled.section`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  font-weight: 700;
`;

export const ContainerLayout = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.primary};
`;

export const TitleCofirm = styled.div``;

export const NumericColor = styled.span`
  color: #096dd9;
  p {
    margin: 0;
    color: #8c8c8c;
    font-size: 14px;
    font-weight: bold;
  }
`;

export const DeselectTransp = styled.span`
  margin-left: 5px;
`;

export const BR = styled.div`
  margin-top: 10px;
`;

export const NameStrong = styled.span`
  color: #595959;
  font-weight: 700;
  white-space: normal;
  margin: 0;
`;

export const NameTransp = styled.strong`
  padding-left: 10px;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const Btn = styled.div`
  display: inline;
  padding-left: 10px;
`;

export const SpaceDiv = styled.strong`
  display: block;
  font-style: normal;
  font-size: 16px;
  color: #595959;
  margin-left: 38%;
`;

export const Div = styled.div`
  /* margin-top: 1%; */
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #595959;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const Payer = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #595959;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 20px;
`;

export const Footer = styled.strong`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #595959;
  margin-right: 10px;
`;
export const TotalUnit = styled.div`
  color: #096dd9;
  border: solid #22e3f4;
  border-width: 1px 0;
  padding: 10px 0;
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 14px;
`;

export const Value = styled.strong`
  font-style: normal;
  font-size: 16px;
  color: #595959;
  font-weight: 700;
`;

export const Total = styled.div`
  padding: 10px;
  direction: rtl;
  @media (max-width: 600px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 0;
  }
`;

export const Line = styled.div`
  position: static;
  width: 100%;
  height: 0px;
  left: 24px;
  top: 523px;
  border: 1px solid #d9d9d9;
  margin-bottom: 10px;
  margin-top: 15px;
`;

export const End = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
`;

export const StylePagador = styled.span`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px;
  margin: -10px;
  background-color: #ebf5fe;
  border-radius: 5px;
`;

export const ModalTransp = styled.div`
  margin: 4% 4% 0% 4%;
  width: 98%;
`;

export const SelectControl = styled(Select)`
  @media (min-width: 600px) {
    width: 350px;
  }
`;

export const TranspSelect = styled.span`
  flex: none;
  order: 3;
  align-self: stretch;
  flex-grow: 0;
`;

export const EditTransp = styled.span`
  position: absolute;
  margin-left: 68%;
  margin-top: 2%;
`;

export const Endereco = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #bfbfbf;
`;

export const EndEntrega = styled.strong`
  font-style: normal;
  font-size: 14px;
  line-height: 22px;
  display: inline-block;
  white-space: nowrap;
  width: 89%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const NameTransport = styled.strong`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
`;

export const TilteEndTransp = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #bfbfbf;
`;

export const QtdSpacement = styled.span`
  margin-right: 16px;
`;

export const TooltipIcon = styled(Tooltip)`
  margin-left: 4px;
`;
